import cx from 'classnames';
import React, { useContext } from 'react';
import { Select } from '../../../../../../../common';
import { DoorStoreSingleContext } from '../../../../../DoorModal/DoorStoreSingleContext';
import { setReTriggerControlZone, StoreContext } from '../../../../contextExpansionRelay';
import styles from '../../../../expansionRelayModal.module.scss';

type Props = {
	useDoorContext: boolean;
};

const ReTrigger: React.FC<Props> = ({ useDoorContext }) => {
	if (useDoorContext) {
		var {
			contextStateDoor: {
				relay: { reTriggerControlZones, selections },
			},
			dispatcherDoor,
		} = useContext(DoorStoreSingleContext);
	} else {
		var {
			expansionRelayState: { reTriggerControlZones, selections },
			dispatcher,
		} = useContext(StoreContext);
	}

	return (
		<div className={styles.sections}>
			<span>{_('ReTriggerControlZone')}</span>
			<div>
				<Select
					id='relayLogicReTriggerControlZoneDropdown'
					className={cx(styles.select)}
					options={reTriggerControlZones.map(x => ({
						label: x.Name,
						value: x.CZIndex.toString(),
						id: `relayLogicReTriggerControlZoneOption-${x.CZIndex.toString()}`,
					}))}
					onChange={value => {
						useDoorContext ? dispatcherDoor(setReTriggerControlZone(Number(value))) : dispatcher(setReTriggerControlZone(Number(value)));
					}}
					key='reTriggerControlZone'
					value={selections.reTriggerControlZone.toString()}
					getPopupContainer={() => document.getElementById('logicRelayContainer')}
				/>
			</div>
		</div>
	);
};

export { ReTrigger };
